import { render, staticRenderFns } from "./CareerbookList.vue?vue&type=template&id=2fc40aed&scoped=true&"
import script from "./CareerbookList.vue?vue&type=script&lang=js&"
export * from "./CareerbookList.vue?vue&type=script&lang=js&"
import style0 from "./CareerbookList.vue?vue&type=style&index=0&id=2fc40aed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc40aed",
  null
  
)

export default component.exports